import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=0313f6a2&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0313f6a2')) {
      api.createRecord('0313f6a2', component.options)
    } else {
      api.reload('0313f6a2', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=0313f6a2&", function () {
      api.rerender('0313f6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rtsNhqkbXw1G/JS/comp/childrenage.vue"
export default component.exports